import { computed, Ref, unref } from 'vue';
import { UseLiveQueryConfigV2 } from '@libs/use';
import {
  SYMBOL_INSTRUMENT_TRADING_STATE_CHANNEL_PREFIX,
  SYMBOL_TRADE_CHANNEL_PREFIX,
  useLiveSymbolQuery as useLiveBaseSymbolQuery,
} from '@core/symbol';
import { Instrument } from '@libs/api-reference';

import useActiveSymbolIsin from './useActiveSymbolIsin';

export default function useLiveSymbolQuery(
  id: Ref<string>,
  {
    immediate = true,
    staleTime = 0,
  }: Pick<UseLiveQueryConfigV2<Instrument>, 'staleTime' | 'immediate'> = {}
) {
  const { activeIsin } = useActiveSymbolIsin();

  const shouldFetch =
    typeof immediate === 'function' ? immediate() : unref(immediate);

  const {
    symbol,
    getSymbol,
    isLoadingSymbol,
    isErrorSymbol,
    isRevalidatingSymbol,
    symbolStatus,
  } = useLiveBaseSymbolQuery(id, {
    immediate: computed(() => Boolean(id.value) && shouldFetch),
    staleTime,
    unsubscribe: (channelName) => {
      return !(
        channelName.includes(activeIsin.value) ||
        channelName.includes(SYMBOL_TRADE_CHANNEL_PREFIX) ||
        channelName.includes(SYMBOL_INSTRUMENT_TRADING_STATE_CHANNEL_PREFIX)
      );
    },
  });

  return {
    symbol,
    getSymbol,
    isLoadingSymbol,
    isErrorSymbol,
    isRevalidatingSymbol,
    symbolStatus,
  };
}
